import type { ReactNode } from 'react';
import styles from '@/styles/ui.module.css';
import AppHeader from './AppHeader';

interface LayoutProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  showBack?: boolean;
  showActions?: boolean;
  showSearch?: boolean;
  onSearch?: (query: string) => void;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
}

export default function Layout({
  children,
  title,
  subtitle,
  showBack = false,
  showActions = true,
  showSearch = false,
  onSearch,
  searchValue = '',
  onSearchChange,
}: LayoutProps) {
  return (
    <div className={styles.layoutContainer}>
      {title && (
        <AppHeader title={title} subtitle={subtitle} showBack={showBack} showActions={showActions} />
      )}

      {showSearch && (
        <div className={styles.searchRow}>
          <div className={styles.searchField}>
            <label className={styles.searchLabel}>Cliente</label>
            <div className={styles.searchFieldInner}>
              <input
                type="text"
                value={searchValue}
                className={styles.searchInput}
                placeholder="Nombre, Ubicación, ..."
                onChange={(e) => {
                  onSearch?.(e.target.value);
                  onSearchChange?.(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      )}

      <main className={`${styles.layoutMain} ${!showSearch ? styles.layoutMainSpaced : ''}`.trim()}>
        {children}
      </main>
    </div>
  );
}
